import React, { useEffect } from 'react';
import { Button, Input, Space, message } from 'antd';
import { ScanOutlined, QuestionCircleOutlined, PrinterOutlined } from '@ant-design/icons';

const { TextArea } = Input;

const ScanInput = ({ 
  inputText, 
  setInputText, 
  batchInput, 
  setBatchInput, 
  handleSearch, 
  handleBatchPrint,
  batchLoading,
  setInstructionModalVisible,
  textAreaRef,
  usePluginPrint
}) => {
  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.focus();
    }
  }, []);

  return (
    <div style={{ marginBottom: '16px' }}>
      <TextArea
        value={batchInput}
        onChange={(e) => setBatchInput(e.target.value)}
        placeholder="批量输入订单号或快递单号，每行一个"
        style={{ marginBottom: '8px' }}
        rows={4}
      />
      <Space style={{ marginBottom: '8px', width: '100%', justifyContent: 'flex-end' }}>
        {!usePluginPrint && (
          <Button
            icon={<QuestionCircleOutlined />}
            onClick={() => setInstructionModalVisible(true)}
          >
            操作方法
          </Button>
        )}
        <Button
          type="primary"
          icon={<PrinterOutlined />}
          loading={batchLoading}
          onClick={() => {
            if (!batchInput.trim()) {
              message.warning('请输入订单号或快递单号');
              return;
            }
            handleBatchPrint();
          }}
        >
          批量打印
        </Button>
      </Space>
      <Space.Compact block style={{ marginBottom: '8px' }}>
        <Input
          ref={textAreaRef}
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          placeholder="输入订单号或快递单号"
          onPressEnter={() => {
            if (inputText.trim()) {
              handleSearch(inputText.trim());
              setInputText('');
              textAreaRef.current?.focus();
            }
          }}
        />
        <Button
          type="primary"
          icon={<ScanOutlined />}
          onClick={() => {
            if (inputText.trim()) {
              handleSearch(inputText.trim());
              setInputText('');
              textAreaRef.current?.focus();
            }
          }}
        >
          搜索
        </Button>
      </Space.Compact>
    </div>
  );
};

export default ScanInput;
